export default "__VITE_ASSET__A84RMF4V__"